import React, { useState } from "react";
import { Box, Typography, InputBase, CircularProgress } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const CeilingForm = ({ currentCeiling, onSubmit, submitting }) => {
  const theme  = useTheme();
  const t      = theme.custom;
  const isDark = theme.palette.mode === "dark";
  const [value, setValue] = useState(String(currentCeiling ?? ""));

  const handleSubmit = () => {
    const n = parseInt(value, 10);
    if (isNaN(n) || n < 0 || n > 500) return;
    onSubmit(n);
  };

  return (
    <Box>
      <Typography sx={{
        fontFamily: "'DM Mono', monospace",
        fontSize: "8px", letterSpacing: "0.15em",
        textTransform: "uppercase", color: t.text3, mb: "6px",
      }}>
        Ceiling <span style={{ color: t.accent }}>*</span>
        <span style={{ color: t.text3, marginLeft: "6px", fontWeight: 300 }}>
          (0 – 500)
        </span>
      </Typography>

      <Box sx={{ display: "flex", gap: "8px", alignItems: "center" }}>
        <Box sx={{
          flex: 1, background: t.surface2,
          border: `1px solid ${t.border2}`, borderRadius: "3px",
          padding: "7px 10px", transition: "border-color 0.15s",
          "&:focus-within": { borderColor: t.accent },
        }}>
          <InputBase
            value={value}
            onChange={(e) => setValue(e.target.value.replace(/\D/, ""))}
            placeholder="e.g. 13"
            sx={{
              width: "100%",
              fontFamily: "'Inter', sans-serif",
              fontSize: "20px", fontWeight: 700,
              color: t.accent,
              "& input::placeholder": { color: t.text3, fontSize: "14px", fontWeight: 400 },
            }}
          />
        </Box>

        <Box
          onClick={submitting ? undefined : handleSubmit}
          sx={{
            padding: "10px 20px", borderRadius: "3px",
            cursor: submitting ? "not-allowed" : "pointer",
            background: submitting ? t.surface3 : t.accent,
            fontFamily: "'DM Mono', monospace",
            fontSize: "11px", fontWeight: 600,
            color: submitting ? t.text3 : (isDark ? "#060E0D" : "#fff"),
            display: "flex", alignItems: "center", gap: "6px",
            transition: "all 0.15s",
            "&:hover": submitting ? {} : { opacity: 0.88 },
          }}
        >
          {submitting && <CircularProgress size={10} sx={{ color: "inherit" }} />}
          {submitting ? "Setting..." : "Set Ceiling"}
        </Box>
      </Box>

      <Typography sx={{
        fontFamily: "'DM Mono', monospace",
        fontSize: "9px", color: t.text3, mt: "5px",
      }}>
        Increasing adds FREE slots · Decreasing retires FREE slots only
      </Typography>
    </Box>
  );
};

export default CeilingForm;